import { render } from "./SignUp.vue?vue&type=template&id=787a9f2c&scoped=true"
import script from "./SignUp.vue?vue&type=script&lang=js"
export * from "./SignUp.vue?vue&type=script&lang=js"

import "./SignUp.vue?vue&type=style&index=0&id=787a9f2c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-787a9f2c"

export default script